<template>
  <base-table-wrapper v-if="$route.name === 'EXCMAgreementDeviceList'">
    <template #top-buttons>
    </template>
    <template #filtering>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <div v-else-if="!isLoading && items.length < 1">{{ $t('views.excmdevice.list.noDevices') }}</div>
      <table v-else class="table table-sm table-responsive-md">
        <thead>
        <tr>
          <th></th>
          <th>{{$t('views.excmdevice.show.brand')}}</th>
          <th>{{$t('views.excmdevice.show.model')}}</th>
          <th>{{$t('views.excmdevice.show.serialNumber')}}</th>
          <th>{{$t('views.excmdevice.show.localization')}}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" class="p-2" :key="item['@id']">
          <td>
            <div style="height: 60px; width: 60px; cursor: pointer;" @click="downloadPDF(getIdLink(item['@id']), item.serialNumber)" v-b-tooltip.hover :title="$t('views.excmdevice.show.downloadPDF')">
              <qr-code :text="item['@id']"></qr-code>
            </div>
          </td>
          <td>
            {{item.device.idDeviceModel.idDeviceBrand.brandTitle}}
          </td>
          <td>
            {{item.device.idDeviceModel.model}}
          </td>
          <td>{{item.device.serialNumber}}</td>
          <td>
            <span v-if="item.city">{{item.city}}, </span>
            <span v-if="item.street">{{item.street}} </span>
            <span v-if="item.building">{{item.building}}</span>
          </td>
          <td>
            <div class="btn-group float-right">
              <router-link v-if="ableToEditDevice"  tag="button" class="btn btn-link fa fa-search fa-lg" :to="{name: 'EXCMDeviceShow', params: { id: item['@id'] }}">
              </router-link>
              <router-link v-if="ableToViewDevice" tag="button" class="btn btn-link fa fa-edit fa-lg" :to="{name: 'EXCMDeviceShow', params: { id: item['@id'] }}">
              </router-link>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="view">
        <pagination
          :view="view"
          @getPage="getPage($event)"
        ></pagination>
      </div>
    </template>
  </base-table-wrapper>

  <div v-else>
    <Loader v-if="isLoading"></Loader>
    <div v-else-if="!isLoading && items.length < 1">{{ $t('views.excmdevice.list.noDevices') }}</div>
    <table v-else class="table table-sm table-responsive-md">
      <thead>
      <tr>
        <th></th>
        <th>{{$t('views.excmdevice.show.brand')}}</th>
        <th>{{$t('views.excmdevice.show.model')}}</th>
        <th>{{$t('views.excmdevice.show.serialNumber')}}</th>
        <th>{{$t('views.excmdevice.show.localization')}}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items" class="p-2" :key="item['@id']">
        <td>
          <div style="height: 60px; width: 60px; cursor: pointer;" @click="downloadPDF(getIdLink(item['@id']), item.serialNumber)" v-b-tooltip.hover :title="$t('views.excmdevice.show.downloadPDF')">
            <qr-code :text="item['@id']"></qr-code>
          </div>
        </td>
        <td>
          {{item.device.idDeviceModel.idDeviceBrand.brandTitle}}
        </td>
        <td>
          {{item.device.idDeviceModel.model}}
        </td>
        <td>{{item.device.serialNumber}}</td>
        <td>
          <span v-if="item.city">{{item.city}}, </span>
          <span v-if="item.street">{{item.street}} </span>
          <span v-if="item.building">{{item.building}}</span>
        </td>
        <td>
          <div class="btn-group float-right">
            <router-link tag="button" class="btn btn-link fa fa-search fa-lg" v-if="item" :to="{name: 'EXCMDeviceShow', params: { id: item['@id'] }}">
            </router-link>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPermission, getUserRoles } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import Pagination from '../../Layout/Pagination'
import Swal from 'sweetalert2'
import getId from '@/utils/getIdFromLink'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  components: {
    Loader,
    Pagination,
    BaseTableWrapper
  },

  props: ['idFirm'],

  computed: {
    ...mapGetters({
      deletedItem: 'excmagreementdevice/del/deleted',
      error: 'excmagreementdevice/list/error',
      items: 'excmagreementdevice/list/items',
      isLoading: 'excmagreementdevice/list/isLoading',
      view: 'excmagreementdevice/list/view',
      userDataEmployeeList: 'userdataemployee/list/items'
    }),
    ableToViewDevice () {
      return this.checkRoles('devices', 'EXCMDeviceShow')
    },
    ableToEditDevice () {
      return this.checkRoles('devices', 'EXCMDeviceUpdate')
    }
  },

  beforeCreate () {
    // checkPagePermission('devices', 'EXCMAgreementDeviceList')
  },

  created () {
    if (this.$route.name === 'EXCMDeviceList') this.getEmployer()
  },

  watch: {
    idFirm: {
      immediate: true,
      handler (val) {
        this.getList(getId(val))
      }
    },

    userDataEmployeeList (val) {
      if (val.length > 0) {
        this.getList(getId(val[0].firm['@id']))
      }
    }
  },

  methods: {
    getList (idFirm = '') {
      let params = { 'agreement.company': idFirm }
      let link = addParamsToQuery('e_x_c_m_agreement_devices', params)
      this.getPage(link)
    },

    getEmployer () {
      let link = addParamsToQuery('user_data_employees', { employee: getUserRoles().id_userdata })
      this.getUserDataEmployee(link)
    },

    ...mapActions({
      getPage: 'excmagreementdevice/list/default',
      getUserDataEmployee: 'userdataemployee/list/default'
    }),

    downloadPDF (id, deviceSerialNumber) {
      this.$http
        .get('api/e_x_c_m_devices/' + id + '/getqrcode', {
          responseType: 'arraybuffer'
        })
        .then(response => {
          var myBlob = new Blob([response.data], { type: 'application/pdf' })
          var url = window.URL.createObjectURL(myBlob)
          var a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          let fileName = 'device_' + deviceSerialNumber + '.pdf'
          a.download = fileName // Name file to download
          a.click()
          setTimeout(function () { window.URL.revokeObjectURL(url) }, 0)
        })
        .catch(error => {
          Swal({
            type: 'error',
            title: this.$t('notifications.store.errorTitle') + ' - ' + error,
            showConfirmButton: false,
            timer: 2500
          })
        })
    },

    getIdLink (link) {
      return getId(link)
    },

    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>
